export interface AIPanelProTip {
  content: string;
}

export const AI_PANEL_PRO_TIPS: AIPanelProTip[] = [
  {
    content:
      '<strong>Click</strong> any node in the mind map to jump to that moment in the transcript',
  },
  {
    content:
      'Click {{shareButton}} at the top of your notes to get a shareable link that you can send to anyone',
  },
  {
    content:
      'Pique automatically drafts a <strong>follow-up email</strong> in your voice after your meetings',
  },
  {
    content:
      'Open your <strong>pre-read</strong> before a session to see context, reminders, and topics likely to come up',
  },
  {
    content:
      'Click {{aiChatButton}} during a session to ask questions in the moment',
  },
  {
    content:
      'Use two fingers to <strong>pinch or scroll</strong> to zoom in/out on your mind map',
  },
  {
    content: 'Type {{commandZ}} to undo anything',
  },
  {
    content:
      'Open the sidebar and click {{feedbackButton}} to quickly share anything with the Pique team',
  },
  {
    content:
      'Click {{openIcon}} on any action item to view context and break it down into smaller, doable steps',
  },
];
